import moment from 'moment';

/** API dates are Gregorian with ASCII digits, regardless of display locale. */
export function formatApiDate(value: moment.MomentInput): string {
  const date = moment(value).locale('en');
  if (!date.isValid()) throw new Error('Invalid API date');
  return date.format('YYYY-MM-DD');
}
